import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import IconUser from 'components/icons/IconUser';

const styles = theme => ({
  iconUser: {
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    padding: '5px 6px',
    borderRadius: '50%',
  },
  iconUserVariantDark: {
    color: theme.palette.secondary['200'],
    background: theme.palette.secondary['400'],
  },
  iconUserVariantLight: {
    color: theme.palette.grey['100'],
    background: theme.palette.primary.A400,
  },
  rootVariantSquare: {
    borderRadius: 0,
  },
});

const Progress = ({
  color, src, variant, className, classes, placeholderImage, ...otherProps
}) => {
  if (!src || src.length === 0) {
    return (
      <Avatar
        className={classNames(className, {
          [classes.rootVariantSquare]: variant === 'square',
        })}
      >
        {placeholderImage || (
          <IconUser
            className={classNames(classes.iconUser, {
              [classes.iconUserVariantDark]: color === 'dark',
              [classes.iconUserVariantLight]: color === 'light',
            })}
          />
        )}
      </Avatar>
    );
  }
  return (
    <Avatar
      className={classNames(className, {
        [classes.rootVariantSquare]: variant === 'square',
      })}
      src={src}
      {...otherProps}
    />
  );
};

Progress.propTypes = {
  color: PropTypes.oneOf(['dark', 'light']),
  variant: PropTypes.oneOf(['circle', 'square']),
  placeholderImage: PropTypes.node,
  src: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    iconUser: PropTypes.string.isRequired,
    iconUserVariantDark: PropTypes.string.isRequired,
    iconUserVariantLight: PropTypes.string.isRequired,
  }).isRequired,
};

Progress.defaultProps = {
  src: null,
  className: '',
  color: 'dark',
  variant: 'circle',
  placeholderImage: null,
};

export default withStyles(styles)(Progress);



// WEBPACK FOOTER //
// ./src/components/common/Avatar.js